import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetProjectSpocsRPC } from "./getProjectSpocsRPC";

export class GetProjectSpocsRPCClientImpl extends GetProjectSpocsRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetProjectSpocsRPC.Request): Promise<LeoRPCResult<GetProjectSpocsRPC.Response, GetProjectSpocsRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "spoc-management/GetProjectSpocs",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetProjectSpocsRPC.ResponseDTO,
      GetProjectSpocsRPC.Errors.ErrorsDTO,
      GetProjectSpocsRPC.Response,
      GetProjectSpocsRPC.Errors.Errors
    >(
      response,
      "spoc-management/GetProjectSpocs",
      GetProjectSpocsRPC.Response.fromDTO,
      GetProjectSpocsRPC.Errors.fromDTO
    );
  }
}
